import type { PartnerBrand } from "../../lib/types";

export function renderHeader(brand: PartnerBrand, calculatorTitle: string): string {
  return `
    <header class="roi-header">
      <div class="brand-wrap" aria-label="${brand.displayName} brand">
        <img class="brand-logo" src="${brand.logoSrc}" alt="${brand.displayName} logo" loading="eager" decoding="async" />
      </div>
      <h1>${calculatorTitle}</h1>
    </header>
  `;
}
